import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../Components/Sidebar";
import Header from "../Components/Header";

function FormInput({ label = "label", name, placeholder, value, onChange, readOnly = false, error }) {
    console.log('value-----------', value)
    return (
        <div className="rp_singleinput_holder mb-3">
            <p className="rp_label mb-2">{label}</p>
            <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                <input
                    type="text"
                    name={name || ""}
                    className="rp_singleInput flex-grow-1"
                    placeholder={placeholder || ""}
                    value={value}
                    onChange={onChange || null}
                    readOnly={readOnly}
                />

            </div>
            {error && <span className="text-danger text-left block">{error}</span>}
        </div>
    );
}

const AddPairsPage = () => {
    return (
        <>
            <Container fluid className="common_bg position-relative">
                <div className="liner"></div>
                <Row>
                    <Col xl={2} lg={0} className="p-0 d-none d-xl-block">
                        <Sidebar />
                    </Col>
                    <Col xl={10} lg={12}>
                        <Header title={"Add Pairs"} />
                        <div className="py-5 px-4 addPairForm">
                            <FormInput label="Price" />
                            <FormInput label="Decimal B" />
                            <FormInput label="Liquidity" />
                            <FormInput label="System A" />
                            <FormInput label="Volume" />
                            <FormInput label="System B" />
                            <FormInput label="Token A" />
                            <FormInput label="Token Name A" />
                            <FormInput label="Token Name B" />
                            <FormInput label="Decimal A" />
                            <div className="adminApprovedPart">
                                <label htmlFor="isAdminApproved">
                                    Is Admin Approved
                                </label>
                                <div className="showAndHideToggle">
                                    <input type="checkbox" id="isAdminApproved" />
                                    <label></label>
                                </div>
                            </div>
                            <div className="d-flex gap-2">
                                <button className="orange_small_primary mt-3">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default AddPairsPage;